import React, { useState } from "react"
import styled from "styled-components"
import { useTranslation } from "react-i18next"

const Container = styled.div`
  display: flex;
  flex-direction: row;
  position: absolute;
  right: 10px;
  top: 10px;
`

const Button = styled.button`
  border: none;
  background: transparent;
  appearance: none;
  opacity: 0.6;
  transition: all 0.3s ease;

  &:hover {
    opacity: 1;
  }

  &.active {
    opacity: 1;
  }
`

const LanguageMenu = () => {
  const { i18n } = useTranslation()

  const [values, setValues] = useState({
    language: "en",
  })

  function handleChange(event) {
    const selected = event.target.value
    i18n.changeLanguage(selected)

    setValues(oldValues => ({
      ...oldValues,
      language: selected,
    }))
  }

  return (
    <Container>
      <Button
        value="en"
        className={values.language === "en" ? "active" : ""}
        onClick={e => handleChange(e)}
      >
        EN
      </Button>
      /
      <Button
        value="es_MX"
        className={values.language === "es_MX" ? "active" : ""}
        onClick={e => handleChange(e)}
      >
        ES
      </Button>
    </Container>
  )
}

export default LanguageMenu
